import { officePaymentAccountConstants } from "../actions/constants";

const initState = {
    paymentMethods: [],
    paymentMethodsSource: "",
    paymentAccounts: [],

    paidAmount: 0,

    loadingMethods: false,
    loadingAccounts: false,
    createLoading: false,
    deleteLoading: false,
    saveMethodLoading: false,

    deletingId: "",

    message: "",
    error: null,
    showAlert: false,
    variantAlert: "success",
};

const getMessage = (payload, fallback = "") => {
    return payload?.message || payload?.error || fallback;
};

const calculatePaidAmount = (paymentAccounts = []) => {
    return paymentAccounts.reduce((sum, item) => {
        if (item?.type !== "client") return sum;

        const price = Number(item?.price || 0);

        return Number.isFinite(price) ? sum + price : sum;
    }, 0);
};

const upsertPaymentAccount = (paymentAccounts = [], paymentAccount) => {
    if (!paymentAccount?._id) return paymentAccounts;

    const exists = paymentAccounts.some((item) => {
        return String(item._id) === String(paymentAccount._id);
    });

    if (!exists) return [paymentAccount, ...paymentAccounts];

    return paymentAccounts.map((item) => {
        return String(item._id) === String(paymentAccount._id)
            ? paymentAccount
            : item;
    });
};

const removePaymentAccount = (paymentAccounts = [], paymentAccountId) => {
    if (!paymentAccountId) return paymentAccounts;

    return paymentAccounts.filter((item) => {
        return String(item._id) !== String(paymentAccountId);
    });
};

export default function officePaymentAccountReducer(state = initState, action) {
    switch (action.type) {
        case officePaymentAccountConstants.OFFICE_PAYMENT_METHODS_REQUEST:
            return {
                ...state,
                loadingMethods: true,
                error: null,
                showAlert: false,
            };

        case officePaymentAccountConstants.OFFICE_PAYMENT_ACCOUNTS_REQUEST:
            return {
                ...state,
                loadingAccounts: true,
                error: null,
                showAlert: false,
            };

        case officePaymentAccountConstants.OFFICE_PAYMENT_ACCOUNT_CREATE_REQUEST:
            return {
                ...state,
                createLoading: true,
                error: null,
                showAlert: false,
            };

        case officePaymentAccountConstants.OFFICE_PAYMENT_ACCOUNT_DELETE_REQUEST:
            return {
                ...state,
                deleteLoading: true,
                deletingId: action.meta?.paymentAccountId || "",
                error: null,
                showAlert: false,
            };

        case officePaymentAccountConstants.OFFICE_PAYMENT_METHOD_SAVE_REQUEST:
            return {
                ...state,
                saveMethodLoading: true,
                error: null,
                showAlert: false,
            };

        case officePaymentAccountConstants.OFFICE_PAYMENT_METHODS_SUCCESS:
            return {
                ...state,
                loadingMethods: false,
                paymentMethods: action.payload?.paymentMethods || [],
                paymentMethodsSource: action.payload?.source || "",
                message: action.payload?.message || "",
                error: null,
            };

        case officePaymentAccountConstants.OFFICE_PAYMENT_ACCOUNTS_SUCCESS: {
            const paymentAccounts = action.payload?.paymentAccounts || [];

            return {
                ...state,
                loadingAccounts: false,
                paymentAccounts,
                paidAmount:
                    action.payload?.paidAmount !== undefined
                        ? Number(action.payload.paidAmount || 0)
                        : calculatePaidAmount(paymentAccounts),
                message: action.payload?.message || "",
                error: null,
            };
        }

        case officePaymentAccountConstants.OFFICE_PAYMENT_ACCOUNT_CREATE_SUCCESS: {
            const paymentAccount = action.payload?.paymentAccount || null;
            const paymentAccounts = paymentAccount
                ? upsertPaymentAccount(state.paymentAccounts, paymentAccount)
                : state.paymentAccounts;

            return {
                ...state,
                createLoading: false,
                paymentAccounts,
                paidAmount:
                    action.payload?.paidAmount !== undefined
                        ? Number(action.payload.paidAmount || 0)
                        : calculatePaidAmount(paymentAccounts),
                message: getMessage(action.payload, "Оплата добавлена"),
                showAlert: true,
                variantAlert: "success",
                error: null,
            };
        }

        case officePaymentAccountConstants.OFFICE_PAYMENT_ACCOUNT_DELETE_SUCCESS: {
            const paymentAccounts = removePaymentAccount(
                state.paymentAccounts,
                action.payload?.paymentAccountId
            );

            return {
                ...state,
                deleteLoading: false,
                deletingId: "",
                paymentAccounts,
                paidAmount:
                    action.payload?.paidAmount !== undefined
                        ? Number(action.payload.paidAmount || 0)
                        : calculatePaidAmount(paymentAccounts),
                message: getMessage(action.payload, "Оплата удалена"),
                showAlert: true,
                variantAlert: "success",
                error: null,
            };
        }

        case officePaymentAccountConstants.OFFICE_PAYMENT_METHOD_SAVE_SUCCESS:
            return {
                ...state,
                saveMethodLoading: false,
                message: getMessage(action.payload, "Способ оплаты обновлён"),
                showAlert: true,
                variantAlert: "success",
                error: null,
            };

        case officePaymentAccountConstants.OFFICE_PAYMENT_METHODS_FAILURE:
            return {
                ...state,
                loadingMethods: false,
                error: action.payload?.error || action.payload?.message || "Ошибка загрузки способов оплаты",
                message: action.payload?.error || action.payload?.message || "Ошибка загрузки способов оплаты",
                showAlert: true,
                variantAlert: "warning",
            };

        case officePaymentAccountConstants.OFFICE_PAYMENT_ACCOUNTS_FAILURE:
            return {
                ...state,
                loadingAccounts: false,
                error: action.payload?.error || action.payload?.message || "Ошибка получения оплат",
                message: action.payload?.error || action.payload?.message || "Ошибка получения оплат",
                showAlert: true,
                variantAlert: "warning",
            };

        case officePaymentAccountConstants.OFFICE_PAYMENT_ACCOUNT_CREATE_FAILURE:
            return {
                ...state,
                createLoading: false,
                error: action.payload?.error || action.payload?.message || "Ошибка добавления оплаты",
                message: action.payload?.error || action.payload?.message || "Ошибка добавления оплаты",
                showAlert: true,
                variantAlert: "warning",
            };

        case officePaymentAccountConstants.OFFICE_PAYMENT_ACCOUNT_DELETE_FAILURE:
            return {
                ...state,
                deleteLoading: false,
                deletingId: "",
                error: action.payload?.error || action.payload?.message || "Ошибка удаления оплаты",
                message: action.payload?.error || action.payload?.message || "Ошибка удаления оплаты",
                showAlert: true,
                variantAlert: "warning",
            };

        case officePaymentAccountConstants.OFFICE_PAYMENT_METHOD_SAVE_FAILURE:
            return {
                ...state,
                saveMethodLoading: false,
                error: action.payload?.error || action.payload?.message || "Ошибка сохранения способа оплаты",
                message: action.payload?.error || action.payload?.message || "Ошибка сохранения способа оплаты",
                showAlert: true,
                variantAlert: "warning",
            };

        case officePaymentAccountConstants.OFFICE_PAYMENT_CLEAR_ALERT:
            return {
                ...state,
                showAlert: false,
                message: "",
                error: null,
            };

        case officePaymentAccountConstants.OFFICE_PAYMENT_CLEAR_STATE:
            return {
                ...initState,
            };

        default:
            return state;
    }
}